"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = require("react");

var _updateDOM = require("./updateDOM");

/**
Modal Hook to manage creation of modal portal root element
The actual function to manipulate the DOM has been moved out
In order to mock it during testing
*/
function useModalPortal(params) {
  if (params === void 0) {
    params = {};
  }

  var _params = params,
      initialPortalTarget = _params.portalTarget;

  var _useState = (0, _react.useState)(initialPortalTarget || null),
      portalTarget = _useState[0],
      setPortalTarget = _useState[1];

  (0, _react.useEffect)(function () {
    if (portalTarget) {
      setPortalTarget(portalTarget);
    } else {
      setPortalTarget((0, _updateDOM.createRootElement)());
    }
  }, [setPortalTarget, portalTarget]);
  return {
    renderNode: portalTarget
  };
}

var _default = useModalPortal;
exports["default"] = _default;